(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5021],{

/***/ 88338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B6": function() { return /* binding */ SPONSORED; },
/* harmony export */   "GF": function() { return /* binding */ ADS; },
/* harmony export */   "YT": function() { return /* binding */ PRODUCT_ATTRIBUTE_LIST_SHOW_WARNING_VOLTAGE_TEXT; },
/* harmony export */   "q7": function() { return /* binding */ TYPE_FLOAT; }
/* harmony export */ });
/* unused harmony export SEARCH_PLACEHOLDER_TEXT */
var ADS = 'ads';
var PRODUCT_ATTRIBUTE_LIST_SHOW_WARNING_VOLTAGE_TEXT = 'product:attributelist:showwarningvoltagetext';
var SEARCH_PLACEHOLDER_TEXT = 'Busca no Magalu';
var SPONSORED = 'patrocinado';
var TYPE_FLOAT = 'typeFloat';

/***/ }),

/***/ 92981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ getProductId; }
/* harmony export */ });
var getProductId = function getProductId(product) {
  return (product == null ? void 0 : product.variationId) || (product == null ? void 0 : product.id);
};

/***/ }),

/***/ 75690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getProductPrice; }
/* harmony export */ });
var getProductPrice = function getProductPrice(product) {
  var _product$price, _product$price2, _product$price3;
  return Number((product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.bestPrice) || (product == null ? void 0 : (_product$price2 = product.price) == null ? void 0 : _product$price2.fullPrice) || (product == null ? void 0 : (_product$price3 = product.price) == null ? void 0 : _product$price3.price) || 0);
};

/***/ }),

/***/ 46729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GF": function() { return /* reexport */ constants/* ADS */.GF; },
  "YT": function() { return /* reexport */ constants/* PRODUCT_ATTRIBUTE_LIST_SHOW_WARNING_VOLTAGE_TEXT */.YT; },
  "B6": function() { return /* reexport */ constants/* SPONSORED */.B6; },
  "q7": function() { return /* reexport */ constants/* TYPE_FLOAT */.q7; },
  "lQ": function() { return /* reexport */ commons_buildCartUrlAndRedirect; },
  "bo": function() { return /* reexport */ shipping/* buildShippingData */.bo; },
  "rz": function() { return /* reexport */ commons_buildWishListActions; },
  "_G": function() { return /* reexport */ shipping/* constants */._G; },
  "D$": function() { return /* reexport */ commons_parseHeaderLinksSuggestions; },
  "b0": function() { return /* reexport */ shipping/* parseShippingVariables */.b0; }
});

// UNUSED EXPORTS: SEARCH_PLACEHOLDER_TEXT, isValidStaticProp, parseEcommerceProductId

;// CONCATENATED MODULE: ../modules/build/esm/commons/buildCartUrlAndRedirect.js
var buildCartUrlAndRedirect = function buildCartUrlAndRedirect(cartRedirect, publish) {
  return function (_ref) {
    var _ref$cartInfo = _ref.cartInfo,
      cartInfo = _ref$cartInfo === void 0 ? {} : _ref$cartInfo,
      _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? '' : _ref$channel,
      clientId = _ref.clientId,
      error = _ref.error,
      location = _ref.location,
      product = _ref.product,
      services = _ref.services,
      typeButton = _ref.typeButton,
      externalCartId = _ref.cartId;
    if (!error) {
      var _product$category, _product$subcategory;
      var cartId = cartInfo.cartId,
        _cartInfo$cartUrl = cartInfo.cartUrl,
        cartUrl = _cartInfo$cartUrl === void 0 ? {} : _cartInfo$cartUrl;
      publish('addtocart:success', {
        cartId: externalCartId || cartId,
        channel: channel,
        clientId: clientId,
        location: location,
        product: product,
        services: services,
        typeButton: typeButton
      });
      var categoryId = product == null ? void 0 : (_product$category = product.category) == null ? void 0 : _product$category.id.toLowerCase();
      var subCategoryId = product == null ? void 0 : (_product$subcategory = product.subcategory) == null ? void 0 : _product$subcategory.id.toLowerCase();
      cartRedirect({
        cartUrl: cartUrl,
        categoryId: categoryId,
        subCategoryId: subCategoryId,
        type: typeButton
      });
    } else {
      publish('addtocart:error', {
        error: error,
        product: product
      });
    }
  };
};
/* harmony default export */ var commons_buildCartUrlAndRedirect = (buildCartUrlAndRedirect);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
;// CONCATENATED MODULE: ../modules/build/esm/commons/buildWishListActions.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var handleWishList = function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(_ref) {
    var actionWishList, customerId, product, name, price, variationId, _yield$actionWishList, data, error;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          actionWishList = _ref.actionWishList, customerId = _ref.customerId, product = _ref.product;
          name = product.title, price = product.price.price, variationId = product.variationId;
          _context.next = 4;
          return actionWishList({
            name: name,
            price: parseFloat(price),
            userId: customerId,
            variationId: variationId
          });
        case 4:
          _yield$actionWishList = _context.sent;
          data = _yield$actionWishList.data;
          error = _yield$actionWishList.error;
          return _context.abrupt("return", {
            data: data,
            error: error
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function handleWishList(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var buildWishListActions = function buildWishListActions(_ref3) {
  var addToWishlist = _ref3.addToWishlist,
    publish = _ref3.publish,
    structure = _ref3.structure,
    removeFromWishlist = _ref3.removeFromWishlist,
    shouldUpdateHeart = _ref3.shouldUpdateHeart;
  return function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2(_ref4) {
      var customerId, isLiked, product, actionWishList, _yield$handleWishList, error;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            customerId = _ref4.customerId, isLiked = _ref4.isLiked, product = _ref4.product;
            actionWishList = isLiked ? removeFromWishlist : addToWishlist;
            _context2.next = 4;
            return handleWishList({
              actionWishList: actionWishList,
              customerId: customerId,
              product: product
            });
          case 4:
            _yield$handleWishList = _context2.sent;
            error = _yield$handleWishList.error;
            if (!error) {
              publish('product:wishlist:click', (0,esm_extends/* default */.Z)({
                stateWishList: !isLiked
              }, product, {
                structure: structure
              }));
              shouldUpdateHeart();
            }
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
};
/* harmony default export */ var commons_buildWishListActions = (buildWishListActions);
// EXTERNAL MODULE: ../modules/build/esm/commons/randomLinksHeader.js
var randomLinksHeader = __webpack_require__(49482);
;// CONCATENATED MODULE: ../modules/build/esm/commons/parseHeaderLinksSuggestions.js


var parseHeaderLinksSuggestions = function parseHeaderLinksSuggestions() {
  var _linksSuggestionsData;
  var linksSuggestionsData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if ((linksSuggestionsData == null ? void 0 : (_linksSuggestionsData = linksSuggestionsData.links) == null ? void 0 : _linksSuggestionsData.length) > 1 && (linksSuggestionsData == null ? void 0 : linksSuggestionsData.title) && (linksSuggestionsData == null ? void 0 : linksSuggestionsData.listSize) && (linksSuggestionsData == null ? void 0 : linksSuggestionsData.maxChars)) {
    return {
      linksSuggestions: (0,esm_extends/* default */.Z)({}, linksSuggestionsData, {
        links: (0,randomLinksHeader/* default */.Z)(linksSuggestionsData, linksSuggestionsData.listSize, linksSuggestionsData.maxChars)
      })
    };
  }
  return {};
};
/* harmony default export */ var commons_parseHeaderLinksSuggestions = (parseHeaderLinksSuggestions);
// EXTERNAL MODULE: ../modules/build/esm/commons/product.js
var product = __webpack_require__(73659);
// EXTERNAL MODULE: ../modules/build/esm/commons/constants.js
var constants = __webpack_require__(88338);
// EXTERNAL MODULE: ../modules/build/esm/commons/shipping/index.js + 3 modules
var shipping = __webpack_require__(73435);
;// CONCATENATED MODULE: ../modules/build/esm/commons/index.js








/***/ }),

/***/ 19951:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var SERVICE_TYPE = 'service';
var isServiceType = function isServiceType(item) {
  return item.type === SERVICE_TYPE;
};
/* harmony default export */ __webpack_exports__["Z"] = (isServiceType);

/***/ }),

/***/ 68909:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var isValidStaticProp = function isValidStaticProp(str) {
  return !!(str && !str.includes('{{'));
};
/* harmony default export */ __webpack_exports__["Z"] = (isValidStaticProp);

/***/ }),

/***/ 17370:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var cnpjMask = function cnpjMask(value) {
  try {
    return value.replace(/\D+/g, '').slice(0, 14).replace(/(\d{2})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1/$2').replace(/(\d{4})(\d)/, '$1-$2');
  } catch (_unused) {
    return '';
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (cnpjMask);

/***/ }),

/***/ 41459:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 39937:
/***/ (function() {

/* (ignored) */

/***/ })

}]);